import { render, staticRenderFns } from "./EvilBots.vue?vue&type=template&id=08efb156&scoped=true"
import script from "./EvilBots.vue?vue&type=script&lang=js"
export * from "./EvilBots.vue?vue&type=script&lang=js"
import style0 from "./EvilBots.vue?vue&type=style&index=0&id=08efb156&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08efb156",
  null
  
)

export default component.exports